var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeyboardopen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6725 11.44H23.7325M9.26746 19.4012H23.7462M9.62496 30.25H23.375M9.98246 2.75H23.0037C23.8975 2.75 24.695 2.7775 25.41 2.87375C29.2187 3.3 30.25 5.0875 30.25 9.9825V18.6725C30.25 23.5675 29.2187 25.355 25.41 25.7812C24.695 25.8775 23.9112 25.905 23.0037 25.905H9.98246C9.08871 25.905 8.29121 25.8775 7.57621 25.7812C3.76746 25.355 2.73621 23.5675 2.73621 18.6725V9.9825C2.73621 5.0875 3.76746 3.3 7.57621 2.87375C8.29121 2.7775 9.08871 2.75 9.98246 2.75Z",
    stroke: "#0FC69A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89307 11.4121H9.90544M14.4306 11.4121H14.4429",
    stroke: "#0FC69A",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardopen);
export default __webpack_public_path__ + "static/media/keyboardopen.e80d77e4ba4479514104d5dd90212659.svg";
export { ForwardRef as ReactComponent };